<!-- 缴费接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/comUpwardStructureForThirdPark"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCode": "2KM43Y461",
          "channelSeq": "0001",
          "userUniqCode": "1231231231"
        },
        responseCode: {
          "data": {
            "selfInRandomCode": "",
            "parkCode": "",
            "channelId": "",
            "passType": "",
            "isParkInOut": "",
            "code": "",
            "carNo": ""
          },
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "智慧停车开放平台主动向第三方车场获取进场随机码，第三方车场车辆自助进场",
          sdkcondition: "cmd=scanChannelQrCodeInForThi",
          httpcondition: this.commonUrls.third+"scanChannelQrCodeInForThi",
          precondition: "无",
          fitSystem: "第三方停车场",
          pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
          frequency:"实时触发",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号' },
              { info1: 'channelId', info2: '是', info3: 'String', info4: '通道ID，停车场方自有的通道ID' },
              { info1: 'userUniqCode', info2: '是', info3: 'String', info4: '第三方所属用户的唯一编码' },
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'selfInRandomCode', info2: '是', info3: 'String', info4: '自助进场随机码' },
              { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
              { info1: 'channelId', info2: '是', info3: 'String', info4: '通道ID，停车场方自有的通道ID' },
              { info1: 'isParkInOut ', info2: '是', info3: 'Integer', info4: '是否整个停车场 0：否 1：是' },
              { info1: 'code', info2: '是', info3: 'Integer', info4: '返回码 0:成功 1:匹配不到进场随机码 2:匹配不到离场随机码 3:未缴费 4:找不到指定的自助码 5:开闸失败 6:已存在关联的自助进场记录 7:找不到指定的停车场 8:当前通道没有车辆 9:查费失败 10:当前通道没有开启自助开闸功能' },
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
            td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForAke/common/scanChannelQrCodeInForThi.vue